export default __webpack_public_path__ + "static/media/113.498f62e1.jpg";